import React from 'react'
import Button from '../../atoms/GoodFlipButton'
import ArrowIcon from '../../atoms/Arrow'
import Text from '../../atoms/Text'
import * as PaymentSuccessAnimation from '../../../assets/animations/payment-success.json'
import FlowerGreen from '../../../assets/images/flower-green.webp'
import PaperEffect from '../../../assets/images/bill-paper-bottom.png'
import CallbackLady from '../../../assets/images/callback-success-lady.webp'
import Lottie from 'lottie-react'

const CallbackSuccessPage = ({ onClick = () => {} }) => {
  return (
    <section className="bg-text-success-primary fixed inset-0 overflow-hidden z-[100]">
      <img
        src={FlowerGreen}
        alt="flower"
        className="h-52 w-52 absolute -left-[100px] z-0"
        style={{ top: 'calc(40% - 100px)' }}
      />
      <img
        src={FlowerGreen}
        alt="flower"
        className="h-52 w-52 absolute -right-[100px] z-0"
        style={{ top: 'calc(40% - 100px)' }}
      />
      <div className="p-11 w-full flex flex-col relative justify-center h-screen max-w-lg lg:max-w-xl mx-auto">
        <div className="h-[100px] w-[100px] self-center rounded-full bg-WHITE flex items-center justify-center shadow-2xl z-10">
          <Lottie
            animationData={PaymentSuccessAnimation}
            autoplay
            loop
            className="h-full w-full"
          />
        </div>
        {/* Program Details */}
        <div className="bg-WHITE w-full rounded-t-2xl -mt-[50px] pt-[56px] px-3 pb-4">
          <div className="flex flex-col gap-1 py-2">
            <Text
              tag="p"
              variant="title"
              size="medium"
              className="text-text-primary"
              textalign="center"
            >
              Our Expert team will call you shortly
            </Text>
            <Text
              tag="p"
              variant="label"
              size="medium"
              className="text-text-quartenary"
              textalign="center"
            >
              Estimated Time:
              <Text
                tag="span"
                variant="label"
                size="medium"
                bold={'true'}
                className="text-text-quartenary"
                textalign="center"
              >
                24 hrs
              </Text>
            </Text>
          </div>
          <img src={CallbackLady} alt="lady" className="h-40 w-40 mx-auto" />
        </div>
        <img src={PaperEffect} alt="paper" className="w-full h-6" />
        <div className="w-0 h-12 border-dashed border-WHITE border-[1px] self-center my-2" />
        {/* Next Steps */}
        <div>
          <div className="flex items-center gap-3 bg-WHITE rounded-2xl overflow-hidden p-2.5">
            <div className="">
              <Text
                tag="p"
                variant="label"
                size="medium"
                className="text-text-quartenary"
              >
                Next Steps
              </Text>
              <Text
                tag="p"
                variant="label"
                size="medium"
                className="text-text-primary"
              >
                Sit back and relax, our experts will collect your blood sample
                at the mentioned address
              </Text>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed bottom-0 left-0 right-0 bg-[rgba(255,_255,_255,_0.85)] pb-4 pt-2 z-10">
        <div className="max-w-lg lg:max-w-xl mx-auto">
          <Button
            onClick={onClick}
            title={'Back To Analysis'}
            type="goodflip_primary"
            leftIcon={null}
            rightIcon={<ArrowIcon direction="right" color="#FFFFFF" />}
          />
        </div>
      </div>
    </section>
  )
}

export default CallbackSuccessPage
